import { __decorate } from "tslib";
import { attr, html, when } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/mixin';
import { SVG_CHECKMARK_CIRCLE_OUTLINED, SVG_CLOSE_CIRCLE_OUTLINED } from '@getgo/chameleon-icons';
import { SvgComponent } from '../Svg';
export const snackbarTemplate = (context, _definition) => {
    const svgIconTag = context.tagFor(SvgComponent);
    return html `
  <template role="status">
      <div class="content-container">
        ${when((x) => x.variant === 'success', html `<${svgIconTag} class="snackbar-icon">${SVG_CHECKMARK_CIRCLE_OUTLINED}</${svgIconTag}>`)}
        ${when((x) => x.variant === 'error', html `<${svgIconTag} class="snackbar-icon">${SVG_CLOSE_CIRCLE_OUTLINED}</${svgIconTag}>`)}
        ${when((x) => x.variant !== 'success' && x.variant !== 'error', html `<slot name="icon" class="snackbar-icon"></slot>`)}
        <div class="message">
          <slot name="title"></slot>
          <slot name="message"></slot>
          <slot name="progress"></slot>
        </div>
      </div>
      <div class="actions">
        <slot name="action"></slot>
      </div>
  </template>
`;
};
export class SnackbarComponent extends ChameleonElementMixin(FoundationElement) {
    constructor() {
        super(...arguments);
        this.stacked = false;
        this.centered = false;
        this.variant = 'info';
    }
}
__decorate([
    attr({ mode: 'boolean' })
], SnackbarComponent.prototype, "stacked", void 0);
__decorate([
    attr({ mode: 'boolean' })
], SnackbarComponent.prototype, "centered", void 0);
__decorate([
    attr
], SnackbarComponent.prototype, "variant", void 0);
